export default __webpack_public_path__ + "static/media/nitron_1.8fa43143.jpg";